import React from "react";
import { Row } from 'react-bootstrap';
import './reservation.css';

const ReservationHeader = (props) => {
    let { selectedService = {} } = props;

    const scrollToMyRef = () => {
        window.scrollTo(0, props.serviceref.offsetTop)
        document.getElementById('service-section-header').setAttribute('tabindex', '-1');
        document.getElementById('service-section-header').focus();
    }

    let row = (<Row className='reservation-header-container'>
        <div className='reservation-header-outsideBox d-block d-md-none'>
            <div className='reservation-header-content' data-test-id="reservation-header-title">
                <div className='reservation-header-title text-mob-left '>
                    <h1>{selectedService.treatmentDesc}</h1>
                </div>
                <div className='reservation-view-details font-size-p2 gotham-xn-medium text-mob-left ' data-test-id="view-details" onClick={scrollToMyRef}>
                    <span className="info-circle" aria-hidden="true"></span>
                    View Details
                            </div>
            </div>
        </div>
        <div className='container reservation-header-content d-none d-md-block'>
            <h1 className='reservation-header-title'>
                {selectedService.treatmentDesc}
            </h1>
            <div className='reservation-view-details'>

                <a aria-label={`View Details of ${selectedService.treatmentDesc} `} href="javascript:void(0)" data-test-id="view-details" className='button-link reservation-view-details font-size-p2 gotham-xn-medium' onClick={scrollToMyRef}>
                    <span className="info-circle" aria-hidden="true"></span>
                    View Details
                </a>
            </div>
        </div>

    </Row>)
    return (row)
}


export default ReservationHeader;
